import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StorageService } from '../../services/storage.service';
import { Router } from '@angular/router';
import { AccountItem } from '../../models/accessData.model';
import { Subscription } from 'rxjs';
import { GS1LoadingService } from '@gs1france/gs1-components-library';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AccessDataFromToken } from '../../models/AccessDataFromToken.model';
 import { OAuthService } from 'angular-oauth2-oidc';
 
@Component({
    selector: 'connect',
    templateUrl: './connect.component.html',
})

export class ConnectComponent implements OnInit, OnDestroy {
    accessData: AccessDataFromToken;
    alert?: any = undefined;
    loading: boolean = true;
    inscriptionComplete: boolean = false;
    idCompany : string;
    tokenGS1: string;
    subs : Subscription[] = [];
    selectedCompany : AccountItem;
    isFederation = false;

    constructor(
        private translate: TranslateService,
        private _storageService: StorageService,
        private loadingService: GS1LoadingService,
        private router: Router,
        public authService: OAuthService) {
    }
    
    ngOnDestroy(): void {
       // document.body.className = "";
        this.subs.forEach(sub => sub.unsubscribe());
    }


    async ngOnInit() {
        if (this.authService.hasValidAccessToken()) {
            const token = this.authService.getAccessToken();
        const jwtHelper = new JwtHelperService();
         const decodedToken = jwtHelper.decodeToken(token) as AccessDataFromToken;
        this._storageService.setDecodedToken(decodedToken);

          }
        
        //document.body.className = "bg-grey";    
        this.loading = true;
        this.loadingService.startLoading('entreprises');
        this.accessData = this._storageService.getDecodedToken();
        
        if (!this.accessData || this.accessData === undefined) {
            this.loadingService.stopLoading('entreprises');
            return;
        }
        if(!this._storageService.companyValue) {
            this._storageService.refreshAndGetCompany().then(()=> {});
        }
        const promise = this._storageService.userValue ? Promise.resolve() : this._storageService.getUser();
        promise.catch(error => {
             this.loadingService.stopLoading('entreprises');
        }).finally(() => {
            this.routage(this.idCompany);
        });
        this.idCompany = this.accessData.companyId;
    }


    choose(idCompany: string) {
        this.loading = true;
        this.idCompany = idCompany;
        this._storageService.resetStorage();
        this.routage(idCompany);            
    }


     routage(idCompany: string) { 
         this.getEtatContact();
        if (this.inscriptionComplete) {
            this.initSession();
        }
        else {
            this.loadingService.stopLoading('entreprises');
            this._storageService.isRedirected = true;
            this.router.navigate(["/formulaire-inscription", idCompany]);  
        }
    }

    setErrorMessage(messageKey: string) {
        let message = this.translate.instant(messageKey);
        this.loadingService.stopLoading('entreprises');
        this.loading = false;
        let title = "Erreur";
        this.alert = { class: 'danger', title, message };
    }

    async getEtatContact() {
        try {
            this.inscriptionComplete = this.accessData 
            && this.accessData.contactFirstName
            && this.accessData.contactLastName
            && this.accessData.contactGender
            && this._storageService.userValue
            && this._storageService.userValue.cguAcceptation
            && (this._storageService.userValue.telPrincipal && this._storageService.userValue.telPrincipal.length > 5)

        } catch (err) {
            this.setErrorMessage("ListeEntreprises.RETOURMODIF_KO");
            
        }
    }

      async initSession() {
        try {
            const prevStateStored = localStorage.getItem("gs1-ecli-previous-state");
            const secondPrevStateStored = localStorage.getItem("gs1-ecli-state-apim");
            const stateStandardStored = localStorage.getItem("gs1-ecli-standard-state");
            const routeStored = localStorage.getItem("gs1-ecli-route-state");

            if(stateStandardStored)
            {
                this.loadingService.stopLoading('entreprises');
                this.router.navigateByUrl(stateStandardStored);

            }
            else if (prevStateStored || secondPrevStateStored) {
                 if(!secondPrevStateStored)
                localStorage.removeItem("gs1-ecli-previous-state");
                if(prevStateStored)
                {
                const prevState = JSON.parse(prevStateStored);
                this.loadingService.stopLoading('entreprises');
                localStorage.setItem("gs1-ecli-state-apim", prevState.url);
                this.router.navigateByUrl(prevState.url);
                }
                else if(secondPrevStateStored)
                {
                
                this.loadingService.stopLoading('entreprises');

                this.router.navigateByUrl(secondPrevStateStored);
                }
            } else {
                this.loadingService.stopLoading('entreprises');
                if (routeStored) {
                    const segments = routeStored.split('/');  
                    this.router.navigate(segments);
                } else if( this.accessData.privileges.includes('Féderation')) {
                    this.router.navigate(['/standard']);
                }
                this.loading = false;
                }
            }
         catch (e) {
             this.loadingService.stopLoading('entreprises');
            this.router.navigate(["/unauthorizedContact/" + e]);
        }
    }
    
}